<router-outlet></router-outlet>

<app-loading-spinner color="primary"></app-loading-spinner>